import React, { Component } from 'react';
import { connect } from 'react-redux';
import dates from 'react-big-calendar/lib/utils/dates';
import cn from 'classnames';
import LeaveSlotGroup from './LeaveSlotGroup';
import _ from 'lodash';
import { customActionTypeColor } from '../../_helpers/anction-color';

class LeaveDayColumn extends Component {
  constructor(...args) {
    super(...args);
  }

  componentDidMount = () => {
    // this.slotMetrics = TimeSlotUtils.getSlotMetrics(this.props)
  };

  renderSlot = (key, emp, daysEvents, addStyle) => {
    let evtStyle = '';
    let label = '';
    const empEvents = daysEvents.filter(
      event => event.EmployeeID === emp.EmployeeAutoID
    );
    const evt = _.head(empEvents);

    if (!_.isEmpty(evt)) {
      const filterdAction = _.head(
        this.props.actionTypes.filter(atyp => atyp.value === evt.ActionType)
      );
      let actionLabel =
        _.head(_.head(filterdAction.label.split(' '))) +
        _.head(_.last(filterdAction.label.split(' ')));
      label = actionLabel;

      evtStyle = customActionTypeColor(evt.ActionType).className;
    }

    return (
      <div className={cn('flex-item', evtStyle)}>
        {/* <span className={cn('rbc-label')}>{label}</span> */}
        <span>{label}</span>
      </div>
    );
  };

  render() {
    const {
      rtl,
      isNow,
      resource,
      accessors,
      localizer,
      daysEvents,
      date,
      step,
      timeslots
    } = this.props;

    const props = this.props;

    const min = dates.startOf(date, 'day');
    const max = dates.endOf(date, 'day');

    return (
      <div
        className={cn(
          'rbc-day-slot',
          isNow && 'rbc-now',
          isNow && 'rbc-today'
        )}
      >
        {this.props.employees.map((emp, idx) => (
          <LeaveSlotGroup
            key={idx}
            emp={emp}
            resource={resource}
            renderSlot={this.renderSlot}
            daysEvents={daysEvents}
          />
        ))}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    actionTypes: state.ActionTypesReducer.actionTypes
  };
}

export default connect(mapStateToProps)(LeaveDayColumn);
